(function() { window.GUID_8156e014_5e52_4bf7_9669_e3cc6a9968e6 = { getGuid: function() { return "8156e014-5e52-4bf7-9669-e3cc6a9968e6"; } }; })();
//Patch pour > IE8
Date.now = Date.now || function () { return +new Date; };
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
        'use strict';
        if (this == null) {
            throw new TypeError();
        }
        /* tslint:disable */
        var n, k, t = Object(this), len = t.length >>> 0;
        /* tslint:enable */
        if (len === 0) {
            return -1;
        }
        n = 0;
        if (arguments.length > 1) {
            n = Number(arguments[1]);
            if (n != n) { // shortcut for verifying if it's NaN
                n = 0;
            }
            else if (n != 0 && n != Infinity && n != -Infinity) {
                n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
        }
        if (n >= len) {
            return -1;
        }
        for (k = n >= 0 ? n : Math.max(len - Math.abs(n), 0); k < len; k++) {
            if (k in t && t[k] === searchElement) {
                return k;
            }
        }
        return -1;
    };
}

//# sourceMappingURL=cs.patcheie.js.map
